import { Component, OnInit } from '@angular/core';
import { ConsultationInfoService } from 'src/app/services/StoreService/ConsultationInfoService/consultation-info-service.service';

@Component({
  selector: 'app-reply-message-popup',
  templateUrl: './reply-message-popup.component.html',
  styleUrls: ['./reply-message-popup.component.scss']
})
export class ReplyMessagePopupComponent implements OnInit {

  constructor(
    private consultationInfoService: ConsultationInfoService
  ) { }

  url: string;

  ngOnInit(): void {
    this.url = this.consultationInfoService.getFileURL();
  }

  downloadReport(){
    window.open(this.url, "_blank");
  }

}
